export enum WorkListQuestionType {
    Header = "Header",
    NoInput = "NoInput",
    Text = "Text",
    TextMultiline = "TextMultiline",
    CheckBox = "CheckBox",
    RadioButtons = "RadioButtons",
    RadioYesNo = "RadioYesNo",
    Dropdown = "Dropdown",
    ImageUpload = "ImageUpload",
    ControlPoints = "ControlPoints",
}
